import { Alert, Box, Button, Chip, Typography } from "@mui/material";
import { type FC, useState } from "react";
import type { FieldError } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { Asset } from "../../../../assets/server/digital-asset-service";
import { ContentLibraryModal } from "../../plugins/toolbar/content-library/content-library-modal";

export const ButtonFormContentLibraryLink: FC<{
  onUseAsLink: (url: string) => void;
  onRemoveLink: () => void;
  assets: Asset[];
  assetsError: Error | null;
  formError?: FieldError;
}> = ({ onUseAsLink, onRemoveLink, assets, assetsError, formError }) => {
  const { t } = useTranslation();
  const [libraryOpen, setLibraryOpen] = useState(false);
  const [assetTitle, setAssetTitle] = useState<string | null>(null);

  return (
    <>
      {assetTitle ? (
        <Chip
          variant="filled"
          color="primary"
          key={assetTitle}
          label={assetTitle}
          onDelete={() => {
            onRemoveLink();
            setAssetTitle(null);
          }}
          sx={{ width: "auto", alignSelf: "flex-start" }}
        />
      ) : (
        <>
          {!assetsError && (
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Button
                data-analytics-id="button-form-select-file"
                onClick={() => {
                  setLibraryOpen(true);
                }}
                sx={{ width: "auto", alignSelf: "flex-start" }}
              >
                {t("Select file from Content Library")}
              </Button>
              {assetsError && (
                <Alert severity="error">
                  {t("Error loading Content Library. Please try again later.")}
                </Alert>
              )}
              {formError && (
                <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                  {t("Ensure you select a file")}
                </Typography>
              )}
            </Box>
          )}
        </>
      )}
      <ContentLibraryModal
        open={libraryOpen}
        onClose={() => {
          setLibraryOpen(false);
        }}
        assets={assets}
        onUseAsLink={(url, title) => {
          setAssetTitle(title);
          onUseAsLink(url);
        }}
      />
    </>
  );
};
